import React from 'react';
import '../../CSS/AttendanceModel.css';
import {Card} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import {motion} from 'framer-motion';

function Model(props) {
    const history  = useHistory();
    var index = props.index
    var safe = props.item.message[0]==="c"?true:false;
    var colors = [
        "#b2ff59","#228b22","#f7f700"
    ]
    var color1 = safe?colors[0]:colors[2];
    if(props.item.message[0]==='y'){
        color1 = "#fec25e"
    }

    const pageVariants = {
        initial :{
            opacity: 0,
            scale: 0.5
        },
        in:{
            opacity: 1,
            scale: 1
        },
      };
      
      const pageTransition = {
        type: "tween",
        ease: "anticipate",
        duration: index*0.15
      };

      function fetchDetails(id, name){
        localStorage.setItem("id", id);
        localStorage.setItem("name", name);
        if(props.item.message[0]!=='y'){
            history.push("/attendanceDetails");
        }
      }
    return(
        <motion.div className="MainModel"
        initial="initial"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}>
            <Card
            raised
            className="CourseCode"
            style={{
                backgroundColor:"#ffffff",
                borderRadius:"20px",
                zIndex:"2",
            }}>
                {props.item.course_code}
            </Card>


            <Card
            raised
            className="Model"
            style={{
                backgroundColor:"#762dc4",
                borderRadius:"20px",
            }}
            onClick={()=>{
                fetchDetails(props.item.course_id, props.item.course_name);
            }}>
            <div
            className="Subject">
                {props.item.course_name}
            </div>
            <div
            className="SubjectType">
                {props.item.course_type}
            </div>
            <div 
            className="PercentageBar">
            </div>
            <div
            className="AttendanceNumber">
                {props.item.course_attendance}
            </div>

            <div className="Message" style={{
                color:color1
            }}>
                {props.item.message}
            </div>
            
            </Card>
        </motion.div>
    );
}

export default Model;